import * as ui from "../../core/ui";

export default function () {
    return [
        new ui.Container({
            classes: "col-xs-12",
            components: [
                new ui.InsertTabGroup({
                    id: "LookerDashboardInsertGroup",
                    components: [
                        new ui.InsertTab({
                            iconType: "segment",
                            id: "InsertLookerDashboard",
                            entityType: "Dashboard",
                            friendlyEntityName: "Dashboard",
                            header: "Dashboard",
                            components: [
                                new ui.DropDownList({
                                    id: "AvailableDashboards",
                                    labelAbove: {
                                        type: "ll",
                                        value: "Dashboard"
                                    },
                                    bindValue: "Dashboard",
                                    dataValueField: "LookerKey",
                                    dataTextField: "Title",
                                    valueWidth: 350,
                                    required: true
                                }),
                                new ui.DropDownList({
                                    id: "ScreenName",
                                    labelAbove: {
                                        type: "ll",
                                        value: "Screen"
                                    },
                                    bindValue: "Screen",
                                    template: "#= data.CodeNumber #",
                                    dataValueField: "Id",
                                    dataTextField: "CodeNumber",
                                    valueWidth: 170,
                                    required: true
                                }),
                                new ui.NumericInput({
                                    id: "SortOrder",
                                    labelAbove: "SortOrder",
                                    bindValue: "SortOrder",
                                    valueWidth: 100,
                                    decimals: 0,
                                    format: "#",
                                    min: 1,
                                    required: true
                                })
                            ]
                        })
                    ]
                })
            ]
        }),
        new ui.Grid({
            id: "SPDashboardsGrid",
            stickyDefaultName: "SPDashboardsGrid",
            containerClasses: "col-xs-12 order-grid-container toggle-delete"
        })
    ];
}
